import React from "react";
import { NavLink } from 'react-router-dom';
import LeftVideo from '../assets/videos/new-home-short-video.mp4';
import RightImage from '../assets/images/home-shtlrg-large.jpg';

function shortLargeImage(){
    return(
        <>
        <div className="short_large_image"> 
            <div className="container"> 
                <div className="short_large_image_inner d-flex align-items-center">
                    <div className="short_image_column" data-aos="fade-up" data-aos-delay="700" data-aos-duration="1000">
                        <video autoPlay muted loop playsInline>
                            <source src={LeftVideo} type="video/mp4" />
                        </video>
                    </div>
                    <div className="large_image_column" data-aos="fade-up" data-aos-delay="600" data-aos-duration="1000">
                        <div className="large_image_column_inner position-relative">                                
                            <img src={RightImage} alt="Right Image" className="w-100" />
                            {/* <NavLink className="position-absolute buybtn position-absolute " exact to="">buy coffee</NavLink> */}
                        </div>
                    </div>
                </div>
            </div>             
        </div>        
        </>
    );
}
export default shortLargeImage;